import { ReactNode } from "react";
import { TriangleDownIcon, TriangleUpIcon } from "../../icons";

interface RangePointProps {
  label?: ReactNode;
  direction: "up" | "down";
  iconClassName?: string;
  size: number;
}

export function RangePoint({
  direction,
  label,
  iconClassName = "",
  size,
}: RangePointProps): JSX.Element {
  const Icon = direction === "up" ? TriangleUpIcon : TriangleDownIcon;

  const order = [
    <Icon
      key="icon"
      className={iconClassName}
      style={{
        width: size,
        height: size,
      }}
    />,
    label ?? null,
  ].filter(Boolean);

  return (
    <span className="flex flex-col items-center">
      {direction === "up" ? order : order.reverse()}
    </span>
  );
}

export function ExtendedRangePoint(props: RangePointProps): JSX.Element {
  return (
    <div className="relative top-[-40px]">
      <RangePoint {...props} />
      <div className="h-10 w-[1px] border-l border-dashed border-violet-400 absolute left-1/2 -translate-x-1/2"></div>
    </div>
  );
}
